<template>
	<v-container class="pa-0">
		<!-- Seção de vade-mécuns -->
		<v-row class="mb-8" style="background-color: #F2F2F2; border-radius: 4px">
			<v-col cols="12" md="6" class="d-flex align-center mobileAlign">
				<h2 style="
            font-family: Inter;
            font-weight: bold;
            color: #F15A24;
            line-height: 1;
            font-size: 1.5rem;
            margin: 0;
          ">
					<span style="color: #242424;">Seus</span> vade-mécuns
				</h2>

			</v-col>
			<v-col cols="12" md="6" class="d-flex align-center justify-end mobileAlign">
				<v-btn :disabled="vademecum.length >= limiteVadeMecunsPorPlano"
					@click="showDialogAddVade = true" large color="#F15A24" dark>
					<v-icon color="white">mdi-plus</v-icon>
					Adicionar vade-mécuns
				</v-btn>
			</v-col>
		</v-row>

		<!-- Grid de vade-mécuns -->
		<v-row class="mb-8">
			<v-col v-for="(v, index) in vademecum" :key="v.id" cols="12" md="6">
				<v-card class="vademecum-card" outlined @click="vademecumSeleceted = { ...v, edit: false }; showDialogVerLeis = true;">
					<v-card-title class="d-flex justify-space-between align-center pa-4">
						<span class="text-h6 font-weight-bold" style="word-break:break-word; max-width: 90%;">
							{{ v.titulo || `Vade-mécum ${index + 1}` }}
							<v-icon :color="v.cor || '#F15A24'" size="20">mdi-circle</v-icon>
						</span>
						<!-- <v-btn icon small @click="excluirVadeMecum(v)" text>
							<v-icon>mdi-delete</v-icon>
						</v-btn> -->

						<v-menu offset-y>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" style="color: #000 !important">
									<v-icon>mdi-dots-vertical</v-icon>
								</v-btn>
							</template>

							<v-list>
								<v-list-item >
									<v-btn  small text @click="excluirVadeMecum(v)">
										<v-icon class="mr-2">mdi-delete</v-icon> Excluir
									</v-btn>
								</v-list-item>
							</v-list>
						</v-menu>

					</v-card-title>

					<v-card-text class="pa-4">
						<div class="mb-3">


							<!-- Mostrar apenas se houver leis -->
							<v-chip v-if="v.leis && v.leis.length > 0" style="border-radius: 4px" color="#F15A24"
								text-color="white" small class="mr-2 mb-2">
								{{ v.leis.length }} {{ v.leis.length === 1 ? 'Lei' : 'Leis' }}
							</v-chip>

							<!-- Contagem projetos de leis -->
							<v-chip v-if="v.projetos_leis && v.projetos_leis.length > 0"
								style="border-radius: 4px" outlined color="#F15A24" small
								class="mr-2 mb-2">
								{{ v.projetos_leis ? v.projetos_leis.length : 0 }}
								Projetos de Lei
							</v-chip>
						</div>
					</v-card-text>

					<!-- Footer do card com status e botão -->
					<v-card-actions class="pa-4"
						style="display: flex; justify-content: space-between; align-items: center;">
						<!-- Status real do vade-mécum -->
						<div class="d-flex align-center">
							<v-icon small class="mr-2">{{v.status === 'public' ? 'mdi-eye' : 'mdi-eye-off'}}</v-icon>
							<span class="">{{ getVadeMecumStatus(v) }}</span>
						</div>

						<!-- Informações adicionais se disponíveis -->
						<v-btn text
							color="#F15A24">
							<v-icon>mdi-book-open-page-variant-outline</v-icon>
							Abrir
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

		<!-- Vades Mecuns sugeridos -->
			<v-row class="mb-8" style="background-color: #F2F2F2; border-radius: 4px">
			<v-col cols="12" class="d-flex align-center mobileAlign">
				<h2 style="
            font-family: Inter;
            font-weight: bold;
            color: #F15A24;
            line-height: 1;
            font-size: 1.5rem;
            margin: 0;
          ">
					Vade-mécuns <span style="color: #242424;">sugeridos pela </span> mylegis
				</h2>	</v-col>
			</v-row><v-row>
				
			<v-col cols="12" v-if="loadingSuggestedVades" class="d-flex justify-center">
				<v-progress-circular indeterminate color="#F15A24"></v-progress-circular>
			</v-col>
			<template v-else>
				<v-col v-for="(v, idx) in suggestedVademecuns" :key="`sug-${v.id}`" cols="12" md="6">
					<v-card outlined class="vademecum-card" @click="vademecumSeleceted = { ...v, edit: false, locked:true }; showDialogVerLeis = true;">
						<v-card-title class="d-flex justify-space-between align-center pa-4">
							<span class="text-h6 font-weight-bold">{{ v.titulo || `Vade-mécum ${idx + 1}` }}
								<v-icon :color="v.cor || '#F15A24'" size="20">mdi-circle</v-icon>
							</span>
						</v-card-title>
						<v-card-text class="pa-4">
							<v-chip v-if="v.leis && v.leis.length > 0" style="border-radius: 4px" color="#F15A24" text-color="white" small>
								{{ v.leis.length }} {{ v.leis.length === 1 ? 'Lei' : 'Leis' }}
							</v-chip>

							<v-chip v-if="v.projetos_leis && v.projetos_leis.length > 0" style="border-radius: 4px" color="#F15A24" outlined small>
								{{ v.projetos_leis.length }} {{ v.projetos_leis.length === 1 ? 'Projeto Lei' : 'Projetos Lei' }}
							</v-chip>
						</v-card-text>
						<v-card-actions class="pa-4" style="display:flex; justify-content:flex-end;">
							<v-btn text color="#F15A24" >
								<v-icon>mdi-import</v-icon>
								Importar
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</template>
		</v-row>

		<!-- Sugestão -->
		<div>
			<v-row>
				<v-col class="text-center" style="font-size: 18px">
					Não encontrou a lei desejada?
					<v-btn style="font-size: 18px" @click="showDialogSugestao = true" outlined>Clique aqui</v-btn>
					que adicionaremos para você.
				</v-col>
			</v-row>
		</div>

		<!-- Snackbar -->
		<v-snackbar v-model="snack.show" :timeout="3000" color="success" top>
			{{ snack.text }}
			<template v-slot:action="{ attrs }">
				<v-btn text v-bind="attrs" @click="snack.show = false">
					Fechar
				</v-btn>
			</template>
		</v-snackbar>

		<!-- Dialog adicionar novo vade -->
		<DialogAddVademecum
			v-model="showDialogAddVade"
			:limite-vade-mecuns="limiteVadeMecunsPorPlano"
			:quantidade-vade-mecuns="vademecum.length"
			@saved="onVademecumSaved"
		/>

		<!-- Dialog adicionar lei a vade-mécum -->
		<v-dialog width="500px" v-model="showDialogAddToVade">
			<v-card>
				<v-card-title>Adicionar lei a um vade-mécum</v-card-title>
				<v-card-text>
					<h3>Selecione o vade-mécum</h3>
					<v-select :items="vademecum" item-value="id" item-text="titulo" color="#F15A24"
						v-model="addTo.vademecum"></v-select>
				</v-card-text>
				<v-card-actions class="text-center">
					<v-btn color="#F15A24" dark @click="patchLeiToVadeMecum">Adicionar Vade-mécum</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog ver leis do vade-mécum -->
		<DialogVerLeis
			v-model="showDialogVerLeis"
			:vademecum="vademecumSeleceted"
			:is-admin="true"
			dynamic-color="#F15A24"
			@update-status="updateVadeMecumStatus"
			@add-lei="showDialogAddLeiToVade = true"
			@add-projeto-lei="showDialogAddProjetoLeiToVade = true"
			@import="importarVadeMecum"
			@excluir-lei="excluirLeiVadeMecum"
			@excluir-projeto-lei="excluirProjetoLeiVadeMecum"
			@reload="reloadVadeMecum"
		/>

		<!-- Dialog adicionar projeto de lei ao vade-mécum -->
		<DialogAddProjetoLei
			v-model="showDialogAddProjetoLeiToVade"
			:vademecum-id="vademecumSeleceted.id"
			:vademecum-titulo="vademecumSeleceted.titulo"
			:vademecum-cor="vademecumSeleceted.cor || '#F15A24'"
			:projetos-leis-existentes="vademecumSeleceted.projetos_leis || []"
			dynamic-color="#F15A24"
			@projeto-lei-adicionado="onProjetoLeiAdicionado"
		/>

		<!-- Dialog adicionar legislação ao vade-mécum -->
		<DialogAddLei
			v-model="showDialogAddLeiToVade"
			:vademecum-id="vademecumSeleceted.id"
			:vademecum-titulo="vademecumSeleceted.titulo"
			:vademecum-cor="vademecumSeleceted.cor || '#F15A24'"
			:leis-existentes="vademecumSeleceted.leis || []"
			dynamic-color="#F15A24"
			:show-advanced-filters="true"
			@lei-adicionada="onLeiAdicionada"
		/>

		<!-- Dialog sugestão -->
		<v-dialog width="580px" v-model="showDialogSugestao">
			<v-card>
				<v-card-title class="d-flex justify-space-between">
					<p class="mb-0">Enviar um sugestão</p>
					<v-btn @click="showDialogSugestao = false;" icon>
						X
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-textarea clearable v-model="txtSugestao" color="#f57029"
						placeholder="Escreva aqui a sua sugestão" />
				</v-card-text>
				<v-card-actions class="text-center">
					<v-btn color="#F15A24" dark @click="sendSugestion">Enviar Sugestão</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<style scoped>
.search-field ::v-deep .v-input__slot {
	border-radius: 4px;
	background-color: white;
}

.borda-laranja {
	border: 1px solid #f15a24;
	border-radius: 20px;
	padding: 3px;
}

.boxText {
	background-color: #f15a24;
	padding: 5px 15px;
	color: white;
	width: 185px;
	height: 42px;
	font-size: 22px;
}

.vademecum-card {
	border-radius: 12px;
	transition: all 0.3s ease;
	height: auto;
}

.vademecum-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

a {
	text-decoration: none;
}

a:hover h2,
a:hover p {
	text-decoration: underline;
}

.resumoNoticia {
	font-size: 1.1rem !important;
	white-space: initial;
}

.highlightText {
	color: red;
}

.my-orange {
	background-color: #F15A24;
	color: white;
	padding: 2px 4px;
	border-radius: 3px;
	font-weight: bold;
}

.bkgHover {
	background-color: rgba(0, 0, 0, 0.08) !important
}

.fullscreen-dialog {
	height: 100vh;
	overflow-y: auto;
}

.empty-state-box {
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	background-color: #fafafa;
}

.dialog-bottom-transition-enter-active,
.dialog-bottom-transition-leave-active {
	transition: transform 0.3s ease-in-out;
}

.dialog-bottom-transition-enter,
.dialog-bottom-transition-leave-to {
	transform: translateY(100%);
}

.search-container {
	background-color: #f5f5f5;
	border-radius: 4px;
	margin: 0 auto;
}

@media (max-width: 600px) {
	.displayMobile {
		display: block !important;
	}

	.mobileAlign {
		justify-content: center !important;
	}

	.mobileGap {
		gap: 24px;
	}

	.mobileConfig {
		display: grid !important;
		justify-content: center !important;
		gap: 10px !important;
	}
}

.texto-multilinha {
	color: #666;
	font-size: 0.875rem;

	/* Trunca após 2 linhas */
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.4;
	max-height: calc(1.4em * 2);
	/* altura de 2 linhas */
}
</style>

<script>
//import BtnCompartilhar from "../components/BtnCompartilahr.vue";
import DialogAddVademecum from '@/components/DialogAddVademecum.vue';
import DialogVerLeis from '@/components/DialogVerLeis.vue';
import DialogAddLei from '@/components/DialogAddLei.vue';
import DialogAddProjetoLei from '@/components/DialogAddProjetoLei.vue';

export default {
	name: 'Legislacoes',
	components: { DialogAddVademecum, DialogVerLeis, DialogAddLei, DialogAddProjetoLei },
	data() {
		return {
			// nick: '',
			// nicks: [],
			idleis: [],
			filterEsfera: 0,
			filterEsferaProjetoLei: 0,
			showVadeDialog: false,
			editNickVadeMecum: 0,
			novoApelido: '',
			editing: [],
			showDialogVerLeis: false,
			showDialogAddLeiToVade: false,
			showDialogAddProjetoLeiToVade: false,
			vademecumSeleceted: { projetos_leis: [], leis: [], edit: false },
			navigating: false,
			statusVadeMecun: [
				{ id: 'published', text: 'Privado' },
				{ id: 'public', text: 'Público' },
			],
			vademecum: [],
			addTo: {},
			showDialogAddVade: false,
			first: false,
			showDialogAddToVade: false,
			loadingNewVade: false,
			loadingNewNick: false,
			disable: true,
			newVadeMecum: '',
			newVadeMecumColor: '',
			page: 1,
			perPageSelected: 0,
			perPage: [5, 10, 25],
			order: 'ASC',
			searchNoticia: null,
			buscou: false,
			resetPages: false,
			loading: true,
			selected: [],
			noticiasDestaque: [],
			items: [],
			searchAddLeis: '',
			searchAddProjetoLeis: '',
			filterOptions: [
				{ text: 'Todas', value: 'Todos', disabled: false },
				{ text: 'Federal', value: 'Federal', disabled: false },
				{ text: 'Estadual', value: 'Estadual', disabled: false },
				{ text: 'Municipal', value: 'Municipal', disabled: false },
			],
			filterProjetoLeiOptions: [
				{ text: 'Todas', value: 'Todos', disabled: false },
				// { text: 'Federal', value: 'Federal', disabled: false },
				{ text: 'Estadual', value: 'Estadual', disabled: false },
				// { text: 'Municipal', value: 'Municipal', disabled: false },
			],
			selectEstadualProjetoLeiOptions: [
				{ text: 'Todos', value: '*', disabled: false },
				{ text: 'Rio de Janeiro', value: 'RJ', disabled: false },
			],
			selectEstadualOptions: [
				{ text: 'Todos', value: '*', disabled: false },
				{ text: 'Rio de Janeiro', value: 'RJ', disabled: false },
				{ text: 'São Paulo', value: 'SP', disabled: false },
				{ text: 'Belo Horizonte', value: 'MG', disabled: false },
			],
			selectMunicipalOptions: [
				{ text: 'Todos', value: '*', disabled: false },
				{ text: 'Rio de Janeiro', value: 'RJ', disabled: false },
				{ text: 'São Paulo', value: 'SP', disabled: false },
			],
			selectEstadualSelected: '*',
			selectMunicipalSelected: '*',
			currentPage: 1,
			itemsPerPage: 10,
			patchLoading: [],
			internalLeisSearch: [],
			internalProjetoLeisSearch: [],
			imgs: [],
			totalItems: 0,
			totalFiltrado: 0,
			loadingInternalSearch: false,
			loadingProjetoLeiInternalSearch: false,
			loadingSearch: false,
			loadingProjetoLeiSearch: false,
			filterTags: [],
			allTags: [],
			swatches: [
				['#FF0000', '#AA0000', '#550000'],
				['#FFFF00', '#AAAA00', '#555500'],
				['#00FF00', '#00AA00', '#005500'],
				['#00FFFF', '#00AAAA', '#005555'],
				['#0000FF', '#0000AA', '#000055'],
			],
			snack: {
				show: false,
				text: '',
			},
			resultadoBusca: [],
			buscaVadeMecum: '',
			savingVadeMecum: false,
			showDialogSugestao: false,
			txtSugestao: '',
			// novos estados
			loadingSuggestedVades: false,
			suggestedVademecuns: [],
			searchTimeout: null,
		};
	},
	created() {
		this.loading = true;
		this.reloadVadeMecum();
		this.searchLeisInVadeMecum();
		this.loadSuggestedVademecuns();

		// this.reloadLeisGraphQl()
	},



	methods: {

		toggleVadeMecumStatus(isPublic) {
			const newStatus = isPublic ? 'public' : 'private';
			this.updateVadeMecumStatus(newStatus);
		},

		// Método para atualizar o status no backend
		async updateVadeMecumStatus(newStatus) {
			this.savingVadeMecum = true;

			try {
				await this.$http.patch('/items/vademecums/' + this.vademecumSeleceted.id, {
					status: newStatus
				});

				// Atualizar o status localmente
				this.vademecumSeleceted.status = newStatus;

				// Atualizar na lista de vademecums também
				const vadeIndex = this.vademecum.findIndex(v => v.id === this.vademecumSeleceted.id);
				if (vadeIndex !== -1) {
					this.vademecum[vadeIndex].status = newStatus;
				}

				window.console.log('Status atualizado com sucesso:', newStatus);

			} catch (error) {
				window.console.error('Erro ao atualizar status:', error);
				// Reverter o status em caso de erro
				// (o v-switch será atualizado automaticamente pela reatividade)
			} finally {
				this.savingVadeMecum = false;
			}
		},

		// Método auxiliar para obter o status formatado
		getStatusText(status) {
			switch (status) {
				case 'published':
					return 'Público';
				case 'public':
					return 'Público';					
				case 'private':
					return 'Privado';
				default:
					return 'Privado';
			}
		},

		// *****************************************************

		addLei(lei) {
			if (!this.selectedLeis.find(l => l.id === lei.id)) {
				this.selectedLeis.push(lei);
			}
		},

		removeLei(lei) {
			this.selectedLeis = this.selectedLeis.filter(l => l.id !== lei.id);
		},

		async importarVadeMecum() {
			// Validar limite antes de importar
			if (this.vademecum.length >= this.limiteVadeMecunsPorPlano) {
				const userPlano = this.user && this.user.plano ? this.user.plano : null;
				const planoNome = this.getPlanoNome(userPlano);
				const mensagem = 'Voce atingiu o limite de ' + this.limiteVadeMecunsPorPlano + ' vade-mecuns do ' + planoNome + '. Para importar mais vade-mecuns, faca upgrade do seu plano.';
				alert(mensagem);
				return;
			}

			window.console.log(this.vademecumSeleceted);
			this.loadingNewVade = true;
			const { data } = await this.$http.post('/items/vademecums', {
				titulo: this.vademecumSeleceted.titulo,
				cor: this.vademecumSeleceted.cor,
				status: 'published',
			});

			const mapLeis = (this.vademecumSeleceted.leis || []).map((e) => ({
				leis_id_lei: { id_lei: e.leis_id_lei.id_lei },
				vademecums_id: data.data.id,
			}));

			const mapProjetos = (this.vademecumSeleceted.projetos_leis || []).map((e) => ({
				projetos_leis_id: { id: e.projetos_leis_id.id },
				vademecums_id: data.data.id,
			}));

			for (const law of mapLeis) {
				const lawId = law.leis_id_lei.id_lei;
				const vademecumId = law.vademecums_id;
				
				// Buscar anotações do usuário que criou o vade mecum original
				const responseAnnotations = await this.$http.get(
					`/items/anotacoes?filter[id_lei][_eq]=${lawId}&filter[user_created][_eq]=${this.vademecumSeleceted.user_created}&filter[status][_eq]=published&fields=id_reg,texto,status`
				);
				
				if (responseAnnotations.data.data.length > 0) {
					for (const annotation of responseAnnotations.data.data) {
						// Criar única anotação com status privado
						await this.$http.post(`/items/anotacoes`, {
							status: 'private',
							texto: annotation.texto,
							id_lei: lawId,
							id_reg: annotation.id_reg,
							id_vademecum: vademecumId,
						});
					}
				}
			}

			await this.$http.patch('/items/vademecums/' + data.data.id, {
				...(mapLeis.length > 0 ? { leis: { create: mapLeis } } : {}),
				...(mapProjetos.length > 0 ? { projetos_leis: { create: mapProjetos } } : {}),
			});
			
			this.loadingNewVade = false;
			this.showDialogVerLeis = false;
			this.reloadVadeMecum()
			// this.$router.go("/painel/legislacoes")
		},
		translateVadeMecunStatus(status) {
			switch (status) {
				case 'published':
					return 'Privado';
				case 'public':
					return 'Público';
				default:
					return 'Privado';
			}
		},
		sendSugestion() {

			window.open("https://wa.me/5521991644663?text=" + this.txtSugestao, "_blank")

			// this.$http
			// 	.post('/items/suporte', {
			// 		mensagem: this.txtSugestao,
			// 	})
			// 	.then(() => {
			// 		this.txtSugestao = '';
			// 		this.showDialogSugestao = false;
			// 		alert(
			// 			'Obrigado por nos enviar sua sugestão, retornaremos o mais breve possível.'
			// 		);
			// 	});
		},
		isLeiInVade(id_lei, leis) {
			return leis.some((lei) => lei.leis_id_lei.id_lei === id_lei);
		},

		adicionarLeiNaCriacao(item) {
			// Verificar se já está adicionada
			if (this.idleis.includes(item.id_lei)) {
				return;
			}

			// Ativar loading
			this.$set(item, 'loading', true);

			// Simular um pequeno delay para feedback visual melhor
			setTimeout(() => {
				// Adicionar à lista
				this.idleis.push(item.id_lei);
				
				// Desativar loading
				this.$set(item, 'loading', false);

				// Mostrar confirmação
				this.snack.text = 'Lei adicionada com sucesso!';
				this.snack.show = true;

				// Forçar atualização da view
				this.$forceUpdate();
			}, 300);
		},

		isProjetoLeiInVade(projetoLeiId, leis) {
			return leis.some((lei) => lei.projetos_leis_id.id === projetoLeiId);
		},
		excluirLeiVadeMecum(rel, idVadeMecum) {
			rel.deleting = true;
			this.$http
				.patch('/items/vademecums/' + idVadeMecum, {
					leis: { delete: [rel.id] },
				})
				.then(() => {
					this.reloadVadeMecum(idVadeMecum);
					rel.deleting = false;
				});
			this.$http.get('/items/leis/' + rel.leis_id_lei.id_lei).then((res) => {
				if (res) {
					const newRanking = res.data.data.ranking_lei - 1;
					this.$http.patch('/items/leis/' + rel.leis_id_lei.id_lei, {
						ranking_lei: newRanking,
					});
				}
			});
		},
		excluirProjetoLeiVadeMecum(rel, idVadeMecum) {
			rel.deleting = true;
			this.$http
				.patch('/items/vademecums/' + idVadeMecum, {
					projetos_leis: { delete: [rel.id] },
				})
				.then(() => {
					this.reloadVadeMecum(idVadeMecum);
					rel.deleting = false;
				});

		},
		verProjetoLei(lei) {
			// Prevenir múltiplas chamadas
			if (this.navigating) {
				return;
			}
			
			this.navigating = true;
			
			// Construir a URL primeiro
			const url = `/painel/projeto_lei/${lei.projetos_leis_id.id}/${this.sanitizeTitle(lei.projetos_leis_id.numero)}/${this.sanitizeTitle(this.vademecumSeleceted.titulo)}`;
			
			// Fechar o dialog
			this.showDialogVerLeis = false;
			
			// Aguardar o próximo tick e um pequeno delay para garantir que o dialog feche
			this.$nextTick(() => {
				setTimeout(() => {
					// Navegar para a rota, ignorando erros de navegação duplicada
					this.$router.push(url).catch(err => {
						// Ignorar erros de navegação duplicada - isso é normal quando já estamos na rota
						if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation')) {
							window.console.error('Erro ao navegar:', err);
						}
					}).finally(() => {
						this.navigating = false;
					});
				}, 150);
			});
		},
		isOptionDisabled(option) {
			return option === 'Municipal (Em Breve)';
		},
		editVD() {
			this.vademecumSeleceted.edit = true;
			this.$refs.edit.focus();
			// window.console.log(this.$refs.edit)
		},
		editarVadeMecum() {
			this.savingVadeMecum = true;
			this.$http
				.patch('/items/vademecums/' + this.vademecumSeleceted.id, {
					titulo: this.vademecumSeleceted.titulo,
					cor: this.vademecumSeleceted.cor,
					status: this.vademecumSeleceted.status,
				})
				.then(() => {
					this.savingVadeMecum = false;
					this.vademecumSeleceted.edit = false;
					this.reloadVadeMecum();
				});
		},
		excluirVadeMecum(v) {
			if (
				confirm(
					`Você deseja excluir o vade-mécum ${v.titulo ? v.titulo : ''} ?`
				)
			) {
				this.$http
					.patch('/items/vademecums/' + v.id, {
						status: 'archived',
					})
					.then(() => {
						this.reloadVadeMecum();
					});
			}
		},
		clearVadeMecumBusca() {
			this.vademecumSeleceted.leis.forEach((lei) => {
				lei.retornoBusca = undefined;
			});
			this.buscaVadeMecum = '';

			this.$forceUpdate();
		},
		handlePageChange(page) {
			if (page >= 1 && page <= this.totalPages) {
				this.currentPage = page;
				if (!this.showDialogAddProjetoLeiToVade) this.searchLeisInVadeMecum();
			}
		},
		clearInternalSearch() {
			this.searchAddLeis = '';
			this.totalItems = 0;
			this.internalLeisSearch = [];
			this.currentPage = 1;
			this.searchLeisInVadeMecum();
		},
		clearProjetoLeiInternalSearch() {
			this.searchAddProjetoLeis = '';
			this.totalItems = 0;
			this.internalProjetoLeisSearch = [];
			this.currentPage = 1;
			this.searchProjetoLeisInVadeMecum();
		},
		async reloadVadeMecum(idVadeMecum) {
			const query = `query FilterVadeMecumsByApelidosLeis($user_id:String){
   vademecums(sort: ["-date_created"], filter: { 
     status: {_neq: "archived"}, 
     user_created: { id: { _eq: $user_id}}
   }) {
     id
     titulo
     status
     cor
     id_grupo {
       id
     }
     leis {
       id
       leis_id_lei {
         id_lei
         numero_lei
         data_lei
         estado_lei
         esfera_lei
         nome_lei
         apelidos_leis (sort:["-date_created"], filter: { user_created: { id: { _eq: $user_id}}}){
           id
           apelido
         }
       }
     }
     projetos_leis { 
       id
       projetos_leis_id { 
         id
         numero
         data
         estado
         esfera
         nome
       }
     }
   }
 }`;

			const variables = { user_id: this.user.id };
			try {
				const {
					data: { data },
				} = await this.$http.post('/graphql', {
					query,
					variables,
				});
				
				// Filtrar apenas vade-mécuns pessoais (sem id_grupo)
				// Vade-mécuns criados na tela de legislações não têm id_grupo (null/undefined)
				// Vade-mécuns criados em grupos têm id_grupo preenchido
				const todosVademecums = data && data.vademecums ? data.vademecums : [];
				this.vademecum = todosVademecums.filter(v => {
					// Se id_grupo é null ou undefined, é um vade-mécum pessoal
					if (!v.id_grupo || v.id_grupo === null) {
						return true;
					}
					
					// Se id_grupo é um objeto relacionado (GraphQL retorna objeto com id)
					if (typeof v.id_grupo === 'object' && v.id_grupo.id) {
						return false; // Tem grupo, excluir
					}
					
					// Se id_grupo é um ID direto (string ou número)
					if (v.id_grupo && (typeof v.id_grupo === 'string' || typeof v.id_grupo === 'number')) {
						return false; // Tem grupo, excluir
					}
					
					// Por padrão, se não tem id_grupo válido, incluir
					return true;
				});
			} catch (error) {
				window.console.error('Erro ao carregar vade-mécuns:', error);
				this.vademecum = [];
			}
			if (idVadeMecum) {
				this.vademecumSeleceted = this.vademecum.filter(
					(e) => e.id == idVadeMecum
				)[0];
			}
			if (this.vademecum.length === 0) {
				this.showVadeDialog = true;
			}
		},

		// Buscar Vades Mecuns públicos do perfil Mylegis
		async loadSuggestedVademecuns() {
			try {
				this.loadingSuggestedVades = true;
				// Buscar o usuário "Mylegis" de forma tolerante
				const usersRes = await this.$http.get(
					`/users?limit=1&fields=id,first_name&filter[_or][0][first_name][_icontains]=mylegis&filter[_or][1][last_name][_icontains]=mylegis`
				);
				const users = usersRes && usersRes.data && usersRes.data.data ? usersRes.data.data : [];
				if (users.length === 0) {
					this.suggestedVademecuns = [];
					return;
				}
				const mylegisId = users[0].id;
				// Buscar vade-mécuns públicos desse usuário (apenas pessoais, sem id_grupo)
				const vadesRes = await this.$http.get(
					`/items/vademecums?fields=*,leis.id,leis.leis_id_lei.*&sort=-date_created&filter[user_created][_eq]=${mylegisId}&filter[status][_in]=public&filter[id_grupo][_null]=true`
				);
				this.suggestedVademecuns = vadesRes && vadesRes.data && vadesRes.data.data ? vadesRes.data.data : [];
			} catch (e) {
				window.console.error('Erro ao carregar vades sugeridos:', e);
			} finally {
				this.loadingSuggestedVades = false;
			}
		},


		mapEsferaColor(esfera) {
			switch (esfera) {
				case 'Federal':
					return '#FF0000';
				case 'Estadual':
					return '#f15a24';
				case 'Municipal':
					return '#00FF00';
				default:
					return '#0000FF';
			}
		},
		patchLeiToVadeMecum() {
			this.loadingNewVade = true;
			// this.addTo.items.push(this.addTo.id)
			this.$http
				.patch('/items/vademecums/' + this.addTo.vademecum, {
					leis: {
						create: [
							{
								leis_id_lei: { id_lei: this.addTo.id_lei },
								vademecums_id: this.addTo.vademecum,
							},
						],
					},
				})
				.then(() => {
					this.loadingNewVade = false;
					this.showDialogAddToVade = false;
					this.newVadeMecum = '';
					// window.console.log(res);
					this.reloadVadeMecum(this.addTo.vademecum);
				});
		},
		onVademecumSaved(vademecumData) {
			// Mostrar confirmação de sucesso
			this.snack.text = 'Vade-mécum criado com sucesso!';
			this.snack.show = true;
			
			// Recarregar lista de vade-mécuns
			this.reloadVadeMecum();
		},
		onLeiAdicionada(lei) {
			// Recarregar o vade-mécum após adicionar lei
			this.reloadVadeMecum(this.vademecumSeleceted.id);
		},
		onProjetoLeiAdicionado(projetoLei) {
			// Recarregar o vade-mécum após adicionar projeto de lei
			this.reloadVadeMecum(this.vademecumSeleceted.id);
		},
		makeFavorite(lei) {
			this.$http
				.post('/items/favoritos', {
					id_lei: lei.id_lei,
					observacao: '',
				})
				.then((res) => {
					this.snack.show = true;
					window.console.log(res);
				});
		},
		async getTop10Laws() {
			try {
				const response = await this.$http.get(
					'https://api.mylegis.com.br/items/leis?limit=30&sort=-ranking_lei'
				);
				// window.console.log(response);
				const leis = response.data.data;
				this.internalLeisSearch = leis.slice(0, 30).map(v => ({ ...v, loading: false }));
			} catch (error) {
				window.console.log(error);
			}
		},
		async searchLeisInVadeMecum() {
			// this.currentPage = 1;
			if (this.searchAddLeis == null) this.searchAddLeis = ""
			if (!isNaN(this.searchAddLeis) &&
				this.searchAddLeis.indexOf('.') == -1) {
				this.searchAddLeis = this.searchAddLeis.replace(
					/(\d)(?=(\d{3})+$)/g,
					'$1.'
				);
			}

			// window.console.log({ vade: this.vademecumSeleceted });

			const searchQuery = this.searchAddLeis
				? `search:"${this.searchAddLeis}", `
				: '';

			const offset = (this.currentPage - 1) * this.itemsPerPage;
			// window.console.log(this.filterEsfera)

			let filter = 'filter: { esfera_lei: { _nnull: true}}'
			if (this.filterEsfera == 1) {
				filter = `filter: { esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"} }, `
			}

			if (this.filterEsfera == 2) {
				filter = `filter: {  esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"}
					 ${this.selectEstadualSelected !== "*" ? `, estado_lei: { _eq: "${this.selectEstadualSelected}"}` : ``}
					},`
			}
			if (this.filterEsfera == 3) {
				filter = `filter: { esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"}
					 ${this.selectMunicipalSelected !== "*" ? `, municipio_lei: { _eq: "${this.selectMunicipalSelected}"}` : ``}
					},`
			}


			const query = `
				query FilterByApelidosLeis {
					leis(${filter}${searchQuery}sort: ["-ranking_lei", "-data_lei"], limit: ${this.itemsPerPage}, offset: ${offset}) {
					id_lei
					numero_lei
					data_lei
					nome_lei
					estado_lei
					municipio_lei
					esfera_lei
					ranking_lei
					}
					leis_aggregated(${filter}${searchQuery}) {
					count { id_lei }
					}
				}
				`;

			this.loadingInternalSearch = true;
			this.internalLeisSearch = [];
			this.totalItems = 0
			// window.console.log(query)

			try {
				const response = await this.$http.post(
					'https://api.mylegis.com.br/graphql',
					{ query }
				);
				const { leis, leis_aggregated } = response.data.data;
				this.internalLeisSearch = leis.map(v => ({ ...v, loading: false }));
				this.totalItems = leis_aggregated[0].count.id_lei;
				this.loadingInternalSearch = false;
			} catch (error) {
				this.loadingInternalSearch = false;
				window.console.error('Erro ao buscar as leis:', error.response);
			}
		},
		async searchProjetoLeisInVadeMecum() {
			// this.currentPage = 1;
			if (this.searchAddProjetoLeis == null) this.searchAddProjetoLeis = ""
			// if (!isNaN(this.searchAddProjetoLeis) &&
			// 	this.searchAddProjetoLeis.indexOf('.') == -1) {
			// 	this.searchAddProjetoLeis = this.searchAddProjetoLeis.replace(
			// 		/(\d)(?=(\d{3})+$)/g,
			// 		'$1.'
			// 	);
			// }

			// window.console.log({ vade: this.vademecumSeleceted });

			const searchQuery = this.searchAddProjetoLeis
				? `search:"${this.searchAddProjetoLeis}", `
				: '';

			// const offset = (this.currentPage - 1) * this.itemsPerPage;
			// window.console.log(this.filterEsfera)
			//, codigo: { _neq: "Projeto de Lei"}
			let filter = 'filter: { esfera: { _nnull: true}, numero: { _nnull: true}}'
			if (this.filterEsferaProjetoLei == 1) {
				filter = `filter: { esfera: {_eq: "${this.filterProjetoLeiOptions[this.filterEsferaProjetoLei].value}"} }, `
			}

			if (this.filterEsferaProjetoLei == 2) {
				filter = `filter: {  esfera: {_eq: "${this.filterProjetoLeiOptions[this.filterEsferaProjetoLei].value}"}
					 ${this.selectEstadualSelected !== "*" ? `, estado: { _eq: "${this.selectEstadualSelected}"}` : ``}
					},`
			}
			if (this.filterEsferaProjetoLei == 3) {
				filter = `filter: { esfera: {_eq: "${this.filterProjetoLeiOptions[this.filterEsferaProjetoLei].value}"}
					 ${this.selectMunicipalSelected !== "*" ? `, municipio: { _eq: "${this.selectMunicipalSelected}"}` : ``}
					},`
			}

			//sort: ["-codigo"], limit: ${this.itemsPerPage}, offset: ${offset}
			const query = `
				query FilterByApelidosLeis {
					projetos_leis(${filter}${searchQuery},limit:-1) {
					id
					numero
					data
					nome
					estado
					municipio
					autor
					codigo
					esfera
					ranking
					}
					projetos_leis_aggregated(${filter}${searchQuery}) {
					count { id }
					}
				}
				`;

			this.loadingProjetoLeiInternalSearch = true;
			this.internalProjetoLeisSearch = [];
			this.totalItems = 0
			// window.console.log(query)

			try {
				const response = await this.$http.post(
					'https://api.mylegis.com.br/graphql',
					{ query }
				);
				const { projetos_leis } = response.data.data;
				// this.internalProjetoLeisSearch = projetos_leis.filter(v => v.codigo != `Projeto de Lei` );
				this.internalProjetoLeisSearch = projetos_leis.map(v => ({ ...v, loading: false }))
				const sortedRows = this.internalProjetoLeisSearch.sort((a, b) => {
					const extractNumber = (numeroString) => {
						const match = numeroString.match(/(\d+)\/\d{4}/);
						return match ? parseInt(match[1]) : 0;
					};

					return extractNumber(b.numero) - extractNumber(a.numero);
				});
				this.internalProjetoLeisSearch = sortedRows
				// window.console.log(sortedRows)
				// this.internalProjetoLeisSearch = projetos_leis.map(v => ({...v, loading: false}));
				this.totalItems = this.internalProjetoLeisSearch.length;
				this.loadingProjetoLeiInternalSearch = false;
			} catch (error) {
				this.loadingProjetoLeiInternalSearch = false;
				window.console.error('Erro ao buscar as leis:', error);
			}
		},
		// async reloadApelidos() {
		//   const ids = this.items.map(e => e.id_lei)

		//   const {
		//     data: { data },
		//   } = await this.$http.get(`/items/apelidos_leis?filter[lei][_in]=${ids}&filter[user_created][_eq]=${this.user.id}`);
		//   window.console.log({ids, data})

		// },
		async reloadLeisGraphQl() {
			this.loading = true;
			if (
				this.searchNoticia !== null &&
				!isNaN(this.searchNoticia) &&
				this.searchNoticia.indexOf('.') == -1
			) {
				this.searchNoticia = this.searchNoticia.replace(
					/(\d)(?=(\d{3})+$)/g,
					'$1.'
				);
			}
			let search =
				this.searchNoticia === undefined || this.searchNoticia === null
					? ''
					: `search:"${this.searchNoticia}",`;
			const query = `query FilterByApelidosLeis($user_id:String){
	         leis(${search} sort:["${this.order === 'ASC' ? '-' : ''}data_lei"],
	               limit: ${this.perPage[this.perPageSelected]},
	               offset: ${(this.page - 1) * this.perPage[this.perPageSelected]
				}) {
	           id_lei
	           numero_lei
	           data_lei
			   estado_lei
	           nome_lei
	           apelidos_leis (filter: { user_created: { id: { _eq: $user_id}}}){
	               apelido
	           }
	         }
	         leis_aggregated${search === '' ? `` : `(${search})`} {
	           count { id_lei }
	         }
	     }`;
			const variables = { user_id: this.user.id };
			const {
				data: { data },
			} = await this.$http.post('/graphql', {
				query,
				variables,
			});
			// window.console.log(data)
			this.totalItems = data.data.meta.total_count;
			this.totalFiltrado = data.leis_aggregated[0].count.id_lei;
			this.loading = false;
			if (this.resetPages) {
				this.page = 1;
				this.resetPages = false;
			}
			this.items = data.leis;

			if (this.first) {
				document
					.querySelector('#busca')
					.scrollIntoView({ behavior: `smooth` });
			} else {
				this.first = true;
			}
		},
		reloadLeis() {
			this.reloadLeisGraphQl();
			return;
		},
		oldReloadLeis() {
			let search =
				this.searchNoticia === undefined || this.searchNoticia === null
					? ''
					: 'search=' + this.searchNoticia;
			let sort = `&sort=${this.order === 'ASC' ? '-' : ''}data_lei`;
			let limit = '&limit=' + this.perPage[this.perPageSelected];
			let offset =
				'&offset=' + (this.page - 1) * this.perPage[this.perPageSelected];
			// let filter = "&filter[apelidos_leis][user_created][id][_eq]="+ this.user.id;
			let filter = '';
			// let filters = []
			// this.filterTags.forEach((el,i) => {
			//   if (el) {
			//     filters.push(this.allTags[i])
			//   }
			// })
			// let filter1 = filters.length === 0 ? "" : "&filter[tags][_contains]="+filters.join()
			let meta = '&meta=total_count,filter_count';

			this.loading = true;
			this.items = [];
			this.$http({
				url:
					'items/leis?fields=id_lei,nome_lei,data_lei,numero_lei&' +
					filter +
					search +
					sort +
					limit +
					offset +
					meta,
			}).then(
				(data) => {
					this.items = data.data.data;
					// this.totalItems = data.data.meta.total_count;
					this.totalFiltrado = data.data.meta.filter_count;
					this.loading = false;
					if (this.resetPages) {
						this.page = 1;
						this.resetPages = false;
					}
					// this.reloadApelidos()
					//this.concatTags();
					//window.console.log(this.items);
				},
				(err) => {
					window.console.log(err);
				}
			);
		},
		loadFeaturedImage() {
			let noticiasDestaqueLength = this.noticiasDestaque.length;
			this.noticiasDestaque.forEach((p, i) => {
				if (p.imagem.id != null) {
					this.$http({
						url: 'assets/' + p.imagem.id,
						responseType: 'blob',
					}).then((response) => {
						let reader = new FileReader();
						reader.readAsDataURL(response.data);
						reader.onload = () => {
							this.imgs[p.imagem.id] = reader.result;
							i + 1 === noticiasDestaqueLength ? this.$forceUpdate() : '';
						};
					});
				}
			});
		},
		requireImg(img) {
			return require('../assets/' + img);
		},
		concatTags() {
			this.items.forEach((el) => {
				if (el.tags != null) {
					this.allTags.push(...el.tags);
				}
			});

			this.allTags = this.allTags.filter((item, index) => {
				return this.allTags.indexOf(item) == index;
			});
		},

		sanitizeTitle(title) {
			var slug = '';
			// Change to lower case
			var titleLower = title.toLowerCase();
			// Letter "e"
			slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
			// Letter "a"
			slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
			// Letter "o"
			slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
			// Letter "u"
			slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
			// Letter "d"
			slug = slug.replace(/đ/gi, 'd');
			// Trim the last whitespace
			slug = slug.replace(/\s*$/g, '');
			// Change whitespace to "-"
			slug = slug.replace(/\s+/g, '-');

			return encodeURIComponent(slug);
		},
		searchConteudoVadeMecum() {
			if (this.buscaVadeMecum === '' || !this.vademecumSeleceted.leis || this.vademecumSeleceted.leis.length === 0) {
				return;
			}
			this.loadingSearch = true;
			this.$http
				.get(
					`items/conteudoleis/?search=${this.buscaVadeMecum
					}&limit=-1&filter[id_lei][_in]=${this.vademecumSeleceted.leis
						.map((e) => e.leis_id_lei.id_lei)
						.toString()}`
				)
				.then((res) => {
					let resultadoBusca = [];
					if (res.data && res.data.data && res.data.data.length > 0) {
						res.data.data.forEach((el) => {
							if (resultadoBusca[el.id_lei] === undefined)
								resultadoBusca[el.id_lei] = [];
							resultadoBusca[el.id_lei].push(el);
						});
					}
					// Atualizar resultados de busca para todas as leis
					this.vademecumSeleceted.leis.forEach((lei) => {
						if (resultadoBusca[lei.leis_id_lei.id_lei] === undefined || resultadoBusca[lei.leis_id_lei.id_lei].length === 0) {
							lei.retornoBusca = [];
						} else {
							lei.retornoBusca = resultadoBusca[lei.leis_id_lei.id_lei];
							// Debug: verificar estrutura dos dados
							if (lei.retornoBusca.length > 0) {
								window.console.log('Campos disponíveis no resultado:', Object.keys(lei.retornoBusca[0]));
								window.console.log('Exemplo de resultado:', lei.retornoBusca[0]);
							}
						}
					});
					this.loadingSearch = false;
					this.$forceUpdate();
				})
				.catch((error) => {
					window.console.error('Erro ao buscar conteúdo:', error);
					this.loadingSearch = false;
					// Limpar resultados em caso de erro
					this.vademecumSeleceted.leis.forEach((lei) => {
						lei.retornoBusca = [];
					});
					this.$forceUpdate();
				});
		},
		highlight(content, query) {
			if (!query) {
				return content;
			}
			return content.replace(new RegExp(query, 'gi'), (match) => {
				return '<span class="my-orange">' + match + '</span>';
			});
		},
		truncateText(text, maxLength) {
			if (!text) return '';
			if (text.length <= maxLength) return text;
			
			// Encontra a posição do último espaço antes do limite
			const truncated = text.substring(0, maxLength);
			const lastSpace = truncated.lastIndexOf(' ');
			
			// Corta no último espaço para não cortar palavras no meio
			return text.substring(0, lastSpace > 0 ? lastSpace : maxLength) + '...';
		},
		extractContext(text, query, contextLength = 150) {
			if (!text || !query) return text || '';
			
			// Remove espaços extras e normaliza
			const normalizedText = text.trim();
			const searchQuery = query.trim();
			
			// Encontra a primeira ocorrência da palavra (case insensitive)
			const lowerText = normalizedText.toLowerCase();
			const lowerQuery = searchQuery.toLowerCase();
			const position = lowerText.indexOf(lowerQuery);
			
			// Se não encontrou ou o texto é pequeno, retorna o texto completo
			if (position === -1 || normalizedText.length <= contextLength * 2) {
				return normalizedText;
			}
			
			// Calcula onde começar e terminar o contexto
			let start = Math.max(0, position - contextLength);
			let end = Math.min(normalizedText.length, position + searchQuery.length + contextLength);
			
			// Ajusta para não cortar palavras no meio
			if (start > 0) {
				const spaceAfterStart = normalizedText.indexOf(' ', start);
				if (spaceAfterStart !== -1 && spaceAfterStart < position) {
					start = spaceAfterStart + 1;
				}
			}
			
			if (end < normalizedText.length) {
				const spaceBeforeEnd = normalizedText.lastIndexOf(' ', end);
				if (spaceBeforeEnd > position + searchQuery.length) {
					end = spaceBeforeEnd;
				}
			}
			
			// Extrai o contexto e adiciona reticências se necessário
			let context = normalizedText.substring(start, end);
			if (start > 0) context = '...' + context;
			if (end < normalizedText.length) context = context + '...';
			
			return context;
		},
		getArtigoUrl(lei, resultado) {
			// Cria URL com hash para scrollar até o artigo específico
			const baseUrl = `/painel/lei/${lei.leis_id_lei.id_lei}/${this.sanitizeTitle(lei.leis_id_lei.numero_lei)}`;
			
			// Cria um ID baseado no tipo e número do conteúdo
			if (resultado.tipo_conteudo && resultado.numero_conteudo) {
				const artigoId = `${resultado.tipo_conteudo.toLowerCase()}-${resultado.numero_conteudo}`;
				return `${baseUrl}#${artigoId}`;
			}
			
			return baseUrl;
		},
		postNick(idLei, nick) {
			this.$http
				.post(`items/apelidos_leis`, {
					status: 'Publicado',
					lei: idLei,
					apelido: nick,
				})
				.then((res) => {
					window.console.log(res);
					this.editNickVadeMecum = 0;
				});
		},

		criarApelido(lei) {
			this.editNickVadeMecum = lei.leis_id_lei.id_lei;
			this.novoApelido = '';
			// Focar no campo de input após um pequeno delay
			this.$nextTick(() => {
				const input = document.querySelector('input[placeholder="Digite o apelido"]');
				if (input) {
					input.focus();
				}
			});
		},

		salvarApelido(idLei, apelido) {
			if (apelido && apelido.trim() !== '') {
				this.postNick(idLei, apelido.trim());
			}
		},

		salvarNovoApelido(idLei) {
			if (this.novoApelido && this.novoApelido.trim() !== '') {
				this.postNick(idLei, this.novoApelido.trim());
				this.editNickVadeMecum = 0;
				this.novoApelido = '';
			} else {
				this.cancelarApelido();
			}
		},

		cancelarApelido() {
			this.editNickVadeMecum = 0;
			this.novoApelido = '';
		},

		addLeiToVade(lei, vadeMecum) {
			lei.loading = true;
			this.$http
				.patch('/items/vademecums/' + vadeMecum, {
					leis: {
						create: [
							{
								leis_id_lei: { id_lei: lei.id_lei },
								vademecums_id: vadeMecum,
							},
						],
					},
				})
				.then(() => {
					this.reloadVadeMecum(vadeMecum);
					lei.loading = false;

				});
			this.$http.get('/items/leis/' + lei.id_lei).then((res) => {
				if (res) {
					const newRanking = res.data.data.ranking_lei + 1;
					this.$http.patch('/items/leis/' + lei.id_lei, {
						ranking_lei: newRanking,
					});
				}
			});
		},
		addProjetoLeiToVade(projetoLei, vadeMecum) {
			projetoLei.loading = true;
			this.$http
				.patch('/items/vademecums/' + vadeMecum, {
					projetos_leis: {
						create: [
							{
								projetos_leis_id: { id: projetoLei.id },
								vademecums_id: vadeMecum,
							},
						],
					},
				})
				.then(() => {
					this.reloadVadeMecum(vadeMecum);
					projetoLei.loading = false;
				});
		},

		// Adicionando os métodos que estavam faltando
		getVadeMecumStatus(v) {
			switch (v.status) {
				case 'public':
					return 'Público';  // ← corrigido
				case 'published':
					return 'Privado';  // ← corrigido
				case 'private':
					return 'Privado';  // ← corrigido
				default:
					return 'Privado';
			}
		},

		formatDate(dateString) {
			if (!dateString) return '';
			const date = new Date(dateString);
			return date.toLocaleDateString('pt-BR');
		},

		createApelido() {
			// Implementar criação de apelido
		},

		updateVadeMecumVisibility() {
			// Implementar atualização de visibilidade
			// console.log('Atualizar visibilidade:', this.vademecumSeleceted.status);
		},

		getPlanoNome(plano) {
			// Retorna o nome amigável do plano
			switch (plano) {
				case 'plano-free':
					return 'Plano Iniciante';
				case 'plano-carreira':
					return 'Plano Carreira';
				case 'plano-premium':
					return 'Plano Premium';
				case 'plano-legislativo':
					return 'Plano Legislativo';
				default:
					return 'seu plano';
			}
		},
	},

	computed: {
		limiteVadeMecunsPorPlano() {
			// Retorna o limite de vade-mécuns baseado no plano do usuário
			const plano = this.user && this.user.plano ? this.user.plano : null;
			
			switch (plano) {
				case 'plano-free':
					return 10; // Plano Iniciante: até 3 vade-mécuns
				case 'plano-carreira':
					return 10; // Plano Carreira: até 10 vade-mécuns
				case 'plano-premium':
					return 50; // Plano Premium: até 50 vade-mécuns
				case 'plano-legislativo':
					return 100; // Plano Legislativo: até 100 vade-mécuns
				default:
					// Se não tiver plano definido, assume o plano free
					return 3;
			}
		},
		filteredLeisInVade() {
			const q = (this.buscaVadeMecum || '').trim().toLowerCase();
			if (!q) {
				return this.vademecumSeleceted.leis || [];
			}
			// Durante o loading, mostrar todas as leis
			if (this.loadingSearch) {
				return this.vademecumSeleceted.leis || [];
			}
			// Filtrar apenas leis que têm resultados da busca no banco de dados
			return (this.vademecumSeleceted.leis || []).filter((rel) => {
				// Buscar por conteúdo (se houver resultados de busca no conteúdo)
				return rel.retornoBusca && rel.retornoBusca.length > 0;
			});
		},
		filteredProjetosInVade() {
			const q = (this.buscaVadeMecum || '').trim().toLowerCase();
			if (!q) return this.vademecumSeleceted.projetos_leis || [];
			return (this.vademecumSeleceted.projetos_leis || []).filter((rel) => {
				const p = rel && rel.projetos_leis_id ? rel.projetos_leis_id : {};
				const numero = (p.numero || '').toString().toLowerCase();
				const nome = (p.nome || '').toLowerCase();
				const autor = (p.autor || '').toLowerCase();
				return numero.includes(q) || nome.includes(q) || autor.includes(q);
			});
		},
		isVademecumPublic: {
			get() {
				// CORREÇÃO: published = público (conforme seu backend)
				return this.vademecumSeleceted.status === 'public';
			},
			set(value) {
				// Switch ligado = 'published' (público)
				// Switch desligado = 'private' (privado)  
				const newStatus = value ? 'public' : 'private';
				this.updateVadeMecumStatus(newStatus);
			}
		},
		user() {
			return this.$store.state.user;
		},
		qtdePage() {
			return Math.ceil(
				this.totalFiltrado / this.perPage[this.perPageSelected]
			);
		},
		paginatedItems() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const end = start + this.itemsPerPage;
			return this.internalLeisSearch.slice(start, end);
		},
		totalPages() {
			return Math.ceil(this.totalItems / this.itemsPerPage);
		},
		intBreakPoint() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs':
					return 0;
				case 'sm':
					return 1;
				case 'md':
					return 2;
				case 'lg':
					return 3;
				case 'xl':
					return 4;
				default:
					return 0;
			}
		},
	},
	watch: {
		'$route.params.strFiltro': {
			handler: function (search) {
				if (search) {
					this.searchNoticia = search;
					this.reloadLeis();
				}
			},
			deep: true,
			immediate: true,
		},
		showDialogAddLeiToVade(oldValue, newValue) {
			
			if ((newValue == false) || (oldValue == false)) {
				// this.clearInternalSearch();
			}
		},
		page(oldValue, newValue) {
			if (oldValue != newValue) {
				this.reloadLeis();
			}
		},
		perPageSelected() {
			this.reloadLeis();
		},
		filterTags: {
			handler() {
				this.reloadLeis();
			},
			deep: true,
		},
		searchNoticia(newValue) {
			if (newValue === null) {
				this.buscou = false;
				this.reloadLeis();
			}
		},
		buscaVadeMecum: {
			handler(newValue, oldValue) {
				// Limpar resultados anteriores quando o campo é limpo
				if (!newValue || newValue.trim() === '') {
					this.loadingSearch = false;
					if (this.vademecumSeleceted && this.vademecumSeleceted.leis) {
						this.vademecumSeleceted.leis.forEach((lei) => {
							lei.retornoBusca = undefined;
						});
					}
					this.$forceUpdate();
					return;
				}
				if (oldValue == newValue) {
					return;
				}
				// Buscar no conteúdo das leis com debounce
				if (this.searchTimeout) {
					clearTimeout(this.searchTimeout);
				}
				
				this.loadingSearch = true;
				this.searchTimeout = setTimeout(() => {
					this.searchConteudoVadeMecum();
				}, 300); // Debounce de 300ms
			},
			immediate: false,
		},
	},
};
</script>
